module.exports = __webpack_public_path__ + "images/emoji/stuck_out_tongue_closed_eyes.6461b7c04a534720d592.png";